import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import SetPRTypeForm from "../forms/SetPRType";

class Product extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      mainCats: [],
      sizes: [],
      colors: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      subCats: [],
      tags: [],
      packages: [],
      exelFile: null,
      uploadLoading: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterCheckBox, filterMainCat, filterSubCat, filterSearch } =
      this.state;

    if (filterSearch) params.q = SearchFormat(filterSearch);
    if (filterCheckBox) {
      const filter = filterCheckBox.join(",");

      params.image = filter.indexOf("img") >= 0 ? 1 : 0;
      params.category = filter.indexOf("cat") >= 0 ? 1 : 0;
      params.code = filter.indexOf("cod") >= 0 ? 1 : 0;
      params.isVip = filter.indexOf("vip") >= 0 ? 1 : 0;
      params.hasPrice = filter.indexOf("hasPrice") >= 0 ? 1 : 0;
    }

    if (filterSubCat) params.subCategoryId = filterSubCat;
    else if (filterMainCat) params.categoryId = filterMainCat;

    this.setState({ loading: true });

    API.product
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });


    setTimeout(() => {
      this.formRef.current.handleDidMount(product, 'bazaar');
    }, 0);
  };

  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  showUpload = (product = {}) => {
    this.setState({ visibleUpload: true, selected: product });

    setTimeout(() => {
      this.uploadRef.current.handleDidMount(product.id);
    }, 0);
  };

  hideUpload = () => {
    this.setState({ visibleUpload: false });

    setTimeout(() => {
      this.uploadRef.current.handleWillUnmount();
    }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1, per_page: this.state.pagination.pageSize });
    }, 0);
  };

  handleUpload = (values) => {
    this.setState({ submitting: true });

    API.product
      .addImage(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideUpload();
        this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleStatus = (record) => {
    Modal.confirm({
      title: record.status
        ? Resources.confirmProductDeactivate
        : Resources.confirmProductActivate,
      okText: Resources.yes,
      okType: record.status ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.product
          .statusUpdate(record)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

 
  handleBasic = (record) => {
    Modal.confirm({
      title: record.is_basic
        ? Resources.confirmDeactivate
        : Resources.confirmActivate,
      okText: Resources.yes,
      okType: record.status ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.product
          .basicUpdate(record)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteImage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.store
          .delete(record._id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };


  handleDeleteProduct = (record) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.product
          .delete(record)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };
  handleSubmit = (values) => {
    this.setState({ submitting: true });

    values.id = this.state.selected._id
      API.product
          .setPRType(values)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    
  };

  handleTableChange = (pagination) => {
    this.setState({
      subPagination: { ...this.state.subPagination, ...{ current: pagination.current, pageSize: pagination.pageSize  } }
  });
    console.log(pagination)
    this.fetch({ page: pagination.current, per_page: pagination.pageSize });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    API.category.list({ type: "main" }).then((result) => {
      this.setState({ mainCats: result.data });
    });
    API.size.list().then((result) => {
      this.setState({ sizes: result.data });
    });
    API.color.list().then((result) => {
      this.setState({ colors: result.data });
    });

    API.category.list({ type: "sub" }).then((result) => {
      this.setState({ subCats: result.data });
    });
    //
    // API.tag.list().then((result) => {
    //   this.setState({ tags: result.data });
    // });
    // API.package.list().then((result) => {
    //   this.setState({ packages: result.data });
    // });

    if (catId && subCatId) {
      this.setState({
        filterMainCat: parseInt(catId),
        filterSubCat: parseInt(subCatId),
      });
    }

    setTimeout(() => {
      this.fetch({ page: 1, per_page: this.state.pagination.pageSize });
    }, 0);
  }

  handleUploadFile = async () => {
    this.setState({ uploadLoading: true });
    const formData = new FormData();
    formData.append("file", this.state.exelFile);
    try {
      const data = await API.product.excelUpload(formData);
      console.log(data);
    } catch (error) {
      console.log("Error :");
      console.log(error);
      this.setState({ uploadLoading: false });
      if (error.status === true) {
        message.success(`فایل ${this.state.exelFile.name} با موفقیت آپلود شد.`);
        this.setState({ exelFile: null });
      } else {
        message.error("فایل آپلود نشد. دقت شود فایل از نوع اکسل باشد");
      }
    }
  };

  handleCloseModal = async() => {
    this.setState({ visibleModal: false });
    this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
  }

  render() {
    const {
      data,
      filterMainCat,
      loading,
      mainCats,
      sizes, colors,
      pagination,
      selected,
      subCats,
      submitting,
      tags,
      visibleDrawer,
      visibleModal,
      visibleUpload,
      exelFile,
      packages
    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "title",
      },
      {
        title: Resources.category,
        dataIndex: "id_categories",
        className: "col-center",
        render: (val, record) => {
          let str = "-";

          if (val[0] != undefined) {
            str = val[0].name;

            if (val[1] != undefined) {
              str = `${str} / ${val[1].name}`;
            }
          }

          return str;
        },
      },

      {
        title: Resources.inventory,
        dataIndex: "stock",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.max_count_in_order,
        dataIndex: "max_count_in_order",
        className: "col-center",
        width: "90px",
      },
      
      {
        title: Resources.price,
        dataIndex: "price",
        className: "col-center",
        render: (val, record) =>
          `${PriceFormat(val)}`,
      },
      {
        title: Resources.barcode,
        dataIndex: "barcode",
        className: "col-center",
       
      },
      {
        title: Resources.discount,
        dataIndex: "discount",
        className: "col-center",
        render: (val, record) =>
            `${PriceFormat(val)}`,
      },

      {
        title: Resources.productRelationType,
        dataIndex: "p_r_type_id",
        className: "col-center",
        render: (val, record) => val?.title,
      },

      {
        title: Resources.status,
        dataIndex: "active",
        className: "col-center",
        width: "70px",
        render: (val, record) => (
          <Switch
            size="small"
            checked={(val == true)}
            onClick={() => this.handleStatus(record)}
            // disabled={!permissions.action}
          />
        ),
      },

      {
        title: Resources.showAsBasic,
        dataIndex: "is_basic",
        className: "col-center",
        width: "70px",
        render: (val, record) => (
          <Switch
            size="small"
            checked={(val == true)}
            onClick={() => this.handleBasic(record)}
            // disabled={!permissions.action}
          />
        ),
      },

    ];

    // const subColumns = [
    //   {
    //     title: Resources.images,
    //     dataIndex: "location",
    //     render: (val) => (
    //       <Tooltip
    //         title={
    //           <Avatar
    //             src={`${Constants.imagePathProduct}${val}`}
    //             shape="square"
    //             size={200}
    //           />
    //         }
    //       >
    //         <Avatar
    //           src={`${Constants.imagePathProduct}${val}`}
    //           shape="square"
    //           size="small"
    //         />
    //       </Tooltip>
    //     ),
    //   },
    // ];

    const options = [
      { label: Resources.withoutImage, value: "img" },
      { label: Resources.withoutCategory, value: "cat" },
      { label: Resources.withoutBarcode, value: "cod" },
      { label: Resources.vip, value: "vip" },
      { label: Resources.hasPrice, value: "hasPrice" },
    ];

      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showModal(record)}
              />
            </Tooltip>
      
          </Fragment>
        ),
      });

      // subColumns.push({
      //   title: Resources.action,
      //   dataIndex: "id",
      //   className: "col-center",
      //   width: "80px",
      //   render: (val, record) => (
      //     <Tooltip title={Resources.delete}>
      //       <Button
      //         type="link"
      //         icon={<DeleteOutlined />}
      //         onClick={() => this.handleDelete(record)}
      //       />
      //     </Tooltip>
      //   ),
      // });
    // }

    const Uploader = () => {
      const props = {
        beforeUpload: (file) => {
          this.setState({
            exelFile: file,
          });
        },
        onChange: (info) => {
          console.log(info.fileList);
        },
      };
      return (
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>آپلود فایل</Button>
        </Upload>
      );
    };

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{`${Resources.products} `} </Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
        {/*    <Col xs={24} md={6}>*/}
        {/*      <Select*/}
        {/*        defaultValue={catId ? parseInt(catId) : undefined}*/}
        {/*        filterOption*/}
        {/*        onChange={(value) => this.handleFilter(value, "filterMainCat")}*/}
        {/*        placeholder={Resources.filterByMainCat}*/}
        {/*        optionFilterProp="name"*/}
        {/*        style={{ display: "block" }}*/}
        {/*        showSearch*/}
        {/*        allowClear*/}
        {/*      >*/}
        {/*        {mainCats.map((cat) => (*/}
        {/*          <Select.Option key={cat.id} value={cat.id} name={cat.name}>*/}
        {/*            {cat.name}*/}
        {/*          </Select.Option>*/}
        {/*        ))}*/}
        {/*      </Select>*/}
        {/*    </Col>*/}
        {/*    <Col xs={24} md={6}>*/}
        {/*      <Select*/}
        {/*        defaultValue={subCatId ? parseInt(subCatId) : undefined}*/}
        {/*        filterOption*/}
        {/*        onChange={(value) => this.handleFilter(value, "filterSubCat")}*/}
        {/*        placeholder={Resources.filterBySubCat}*/}
        {/*        optionFilterProp="name"*/}
        {/*        style={{ display: "block" }}*/}
        {/*        showSearch*/}
        {/*        allowClear*/}
        {/*      >*/}
        {/*        {subCats*/}
        {/*          .filter((o) => parseInt(o.subCategory) === filterMainCat)*/}
        {/*          .map((cat) => (*/}
        {/*            <Select.Option key={cat.id} value={cat.id} name={cat.name}>*/}
        {/*              {cat.name}*/}
        {/*            </Select.Option>*/}
        {/*          ))}*/}
        {/*      </Select>*/}
        {/*    </Col>*/}
            <Col xs={24} md={{ span: 6, offset: 6 }}>
              <Tooltip title={Resources.searchHintProduct}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
        {/*    <Col xs={24} sm={18} style={{ paddingTop: 16 }}>*/}
        {/*      <Checkbox.Group*/}
        {/*        options={options}*/}
        {/*        onChange={(value) => this.handleFilter(value, "filterCheckBox")}*/}
        {/*      />*/}
        {/*    </Col>*/}
        {/*    <Col xs={24} sm={6} style={{ paddingTop: 16 }}>*/}
        {/*      /!* {!!exelFile ? (*/}
        {/*        <>*/}
        {/*          <Button onClick={() => this.setState({ exelFile: null })}>*/}
        {/*            <ClearOutlined />*/}
        {/*          </Button>*/}
        {/*          <Button*/}
        {/*            onClick={this.handleUploadFile}*/}
        {/*            loading={this.state.uploadLoading}*/}
        {/*          >*/}
        {/*            آپلود*/}
        {/*          </Button>*/}
        {/*        </>*/}
        {/*      ) : (*/}
        {/*        <Uploader />*/}
        {/*      )} *!/*/}
        {/*    </Col>*/}

            {/* <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
            </Col> */}
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            // expandable={{
            //   expandedRowRender: (record) => (
            //     <Table
            //       columns={subColumns}
            //       dataSource={record.id_stores}
            //       pagination={false}
            //       rowKey="_id"
            //     />
            //   ),
            //   rowExpandable: (record) => !!record.id_stores.length,
            // }}
            size="small"
            rowKey="_id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
   
        <SetPRTypeForm
          ref={this.formRef}
          onCancel={this.handleCloseModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}
        />
       
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(Product);
